module.exports = __webpack_public_path__ + "static/memorial_card_img3-465d602079546211de2aa7df7ba2dab5.jpg";